module.exports = __webpack_public_path__ + "img/ms.cab37729.svg";